import { render, staticRenderFns } from "./SubmissionChangesList.vue?vue&type=template&id=f9b3c47c"
import script from "./SubmissionChangesList.vue?vue&type=script&lang=js"
export * from "./SubmissionChangesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports